module.exports = __webpack_public_path__ + "img/Weapon_13.c44b5d8d.png";